import { ProfilePicture } from '../../../../components/generic'
import { colors } from '@lmc/common/constants'
import { Button, Edit } from '@lmc/ui-kit'
import { isBrowser, isTablet } from 'react-device-detect'
import styled from 'styled-components'

interface ResidentName {
  first: string
  last: string
}

interface Resident {
  picture?: string
  name: ResidentName
}

interface ZoneResidentRowProps {
  onEdit: (resident: Resident) => void
  resident: Resident
  isLast?: boolean
}

export default function ZoneResidentRow({ onEdit, resident, isLast }: ZoneResidentRowProps) {
  return (
    <Container
      className="zone-resident"
      style={!isLast ? { borderBottom: `1px solid ${colors.grey}` } : {}}
    >
      <LeftContainer>
        <ProfilePicture
          style={{ marginRight: 10 }}
          url={resident.picture}
          type="handover__small"
        />
        <NameContainer>
          {resident.name.first} {resident.name.last}
        </NameContainer>
      </LeftContainer>
      <RightContainer>
        <StyledButton
          className={isBrowser || isTablet ? 'hover-buttons' : ''}
          onClick={() => onEdit(resident)}
          variant="default"
        >
          <Edit />
          Edit
        </StyledButton>
      </RightContainer>
    </Container>
  )
}

// Styled Components
const Container = styled.li`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  transition: all 0.2s ease;
  background: ${colors.white};

  &:hover {
    background: ${colors.lightgrey};
  }
`

const LeftContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  min-width: 0;
`

const NameContainer = styled.div`
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
  font-weight: 700;
`

const RightContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-left: 12px;
  min-width: 0;
`

const StyledButton = styled(Button)`
  font-size: 12px;
  transition: all 0.2s ease;
  text-shadow: none;
`
